import React from 'react';
import { Ban, Clock, HeartCrack } from 'lucide-react';
export function PainPoints() {
  const points = [{
    icon: Ban,
    title: "One Size Doesn't Fit All",
    description: 'Generic meal plans ignore your unique lifestyle, preferences, and body. You need a plan built for you, not the masses.'
  }, {
    icon: Clock,
    title: 'Tired of Wasting Time',
    description: "You've spent years on the yo-yo dieting cycle. It's exhausting and ineffective. It's time to stop starting over."
  }, {
    icon: HeartCrack,
    title: "Diets Don't Last",
    description: 'Restriction leads to bingeing. We help you build sustainable habits that stick around long after the coaching ends.'
  }];
  return <section className="py-20 bg-stone-100" data-id="element-132">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-133">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3" data-id="element-134">
          {points.map((point, index) => <div key={index} className="bg-white p-8 rounded-3xl shadow-sm border border-stone-100 hover:shadow-md transition-shadow" data-id="element-135">
              <div className="h-12 w-12 rounded-2xl flex items-center justify-center mb-6" style={{
            backgroundColor: '#4bc04115'
          }} data-id="element-136">
                <point.icon className="h-6 w-6" style={{
              color: '#4bc041'
            }} data-id="element-137" />
              </div>
              <h3 className="font-serif text-xl font-bold text-stone-900 mb-3" data-id="element-138">
                {point.title}
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-139">
                {point.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}